/**
 * Route for `referral-partner`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { ReferralPartnerPage } from "../features/referral-partner/ReferralPartnerPage";

export const referralPartnerRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/referral-partner",
	component: ReferralPartnerPage,
});

export default referralPartnerRoute;
